import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home/Home";
import Layout from "./layouts/Layout";
import { navItemsData } from "./routings";
import Contact from "./containers/Contact/Contact";
import DSP from "./containers/DSP/DSP";
import classes from "./App.module.css";

const App: React.FC = () => {
    return (
        <Layout extraClasses={classes.Main}>
            <Switch>
                <Route path={navItemsData.home.path} exact component={Home} />
                <Route path={navItemsData.contact.path} exact component={Contact} />
                <Route path={navItemsData.dsp.path} exact component={DSP} />
                <Route path="" render={() => <div style={{ textAlign: "center" }}>NOT FOUND!</div>} />
            </Switch>
        </Layout>
    );
};

export default App;
